// OpenAI's citation delimiters: private-use characters that draw as nothing.
const OPEN = String.fromCodePoint(0xe200);
const CLOSE = String.fromCodePoint(0xe201);

/**
 * OpenAI's inline citation markers, which a model leaves in its prose after a provider-run web
 * search: open, `cite`, a separator and the source ids, close. Only the field names would show. A
 * marker still streaming has no closing delimiter yet, so one left open at the end is dropped too
 * rather than flashing half-written.
 */
// eslint-disable-next-line i18next/no-literal-string -- a pattern, not copy
const CITATION_MARKER = new RegExp(`${OPEN}[^${CLOSE}]*(?:${CLOSE}|$)`, 'g');

/** The text as a person should read it, without the citation markers a web search leaves. */
export function withoutCitationMarkers(text: string): string {
  return text.includes(OPEN) ? text.replace(CITATION_MARKER, '') : text;
}
